
<template>
  <div class="builder mode-builder">
    <div class="md-layout" v-if="!noTemplate">
      <div class="md-layout-item">
        <fb-template @load-template="init($event)"></fb-template>
      </div>
    </div>
    <md-tabs>
      <md-tab @click="view_mode = false" id="tab-edit" md-label="Edit"></md-tab>
      <md-tab @click="view_mode = true" id="tab-preview" md-label="Preview"></md-tab>
    </md-tabs>
    <div v-if="view_mode">
      <form novalidate="novalidate">
        <component
          v-for="(element) in jsonView"
          :uuid="element.uuid"
          :key="element.uuid"
          :is="element.type"
          :element="element"
          :mode="true"
          :validate="validate"
          @set-value="setValue"
        ></component>
      </form>
    </div>
    <div v-else class="md-layout">
      <div class="md-layout-item fb-section">
        <div class="full-height">
          <draggable class="dragArea full-height show-draggable dragArea-bottom" tag="div" :list="list" group="controls">
            <component
              v-for="(element, index) in list"
              @save-data="saveData(index, $event)"
              @menu-delete="removeItem(index)"
              :uuid="element.uuid"
              :key="element.uuid"
              :is="element.type"
              :element="element"
              :mode="0"
              :validate="validate"
            ></component>
          </draggable>
          <md-button @click="addCard" class="md-raised md-accent icon-right"><md-icon>add</md-icon> Add Card</md-button>
        </div>
      </div>
      <div class="md-layout-item md-size-30 md-small-size-50 fb-controll-section" ref="control_section">
        <div class="sticky-wrapper" _v-sticky sticky-offset="offset" sticky-side="top">
          <div class="controll-wrapper" :key="index" v-for="(group, index) in controls">
            <div class="controll-button">
              <md-button @click="group.show = !group.show" class="group-controll md-link w-100 d-block"><md-icon>{{ !group.show ? 'expand_more' : 'keyboard_arrow_up' }}</md-icon><span>{{ group.label }}</span></md-button>
            </div>
            <draggable :class="'dragAreaConrol ' + (group.show ? 'visible visible-content' : 'hidden')" v-model="group.elements" class="" v-bind="getOptions()">
              <md-list @click="list.push(clone(element))" v-for="(element, k) in group.elements" :key="k" class="fb-controll-section">
                <fb-delimiter v-if="element.type == 'FbDelimiter'"></fb-delimiter>
                <md-list-item v-else class="md-elevation-2">
                  <md-icon>{{element.icon}}</md-icon>
                  <span class="md-list-item-text">{{element.label}}</span>
                </md-list-item>
              </md-list>
            </draggable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "FormBuilder",
  props: ["mode", "noTemplate"],
  components: {
    draggable
  },
  created() {
    this.list.forEach(element => {
      this.set_uuid(element);
    });
  },
  mounted() {
    this.init();
    this.list.map(this.set_uuid);
    let resizeRafStyle;

    window.addEventListener('resize', ()=>{
      if (resizeRafStyle) {
        cancelAnimationFrame(resizeRafStyle);
      }

      resizeRafStyle = requestAnimationFrame(() => {
        if (document.querySelector('#toolbar-administration + *') && this.$refs["control_section"]) {
          let topPos = document.querySelector('#toolbar-administration + *').offsetTop;
          let max_height = 'calc(100vh - ' + topPos + 'px)';
          this.$refs["control_section"].querySelector('.sticky-wrapper').style.top = (topPos || 0) + 'px';
          this.$refs["control_section"].querySelector('.sticky-wrapper').style.maxHeight = max_height;
        }
      });
    });
    window.dispatchEvent(new Event('resize'));
  },
  computed: {
    json() {
      return JSON.stringify(this.list);
    },
    jsonView() {
      let steps = [];
      let inStep = false;
      let json = JSON.parse(this.json);
      let reorderList = (elements, parent) => {
        let prevElementType = null;
        let list = [];
        elements.forEach((el, index) => {
          el.list = reorderList(el.list, el);
          if (el.type == "FbStep" && prevElementType == "FbStep") {
            list[list.length - 1].list.push(el);
          } else if (el.type == "FbStep") {
            if (
              parent &&
              parent.type == "FbCard" &&
              parent.data.type == "step"
            ) {
              list.push({
                type: "FbSlider",
                data: {},
                list: []
              });
            }
            else if (
              parent &&
              parent.type == "FbCard" &&
              parent.data.type == "form"
            ) {
              list.push({
                type: "FbSliderForm",
                data: {},
                list: []
              });
            }
            else {
              list.push({
                type: "FbStepper",
                data: {},
                list: []
              });
            }

            list[list.length - 1].list.push(el);
          } else {
            list.push(el);
          }
          prevElementType = el.type;
        });
        return list;
      };

      return reorderList(json);
    }
  },
  data() {
    return {
      view_mode: this.mode || false,
      validate: false,
      offset: {top: 80},
      controls: [
        {
          label: 'Organization Elements',
          show: true,
          elements: [
            {
              type: "FbCard",
              label: "Card",
              icon: "tab",
              list: [],
              data: {
                label: "Card",
                value: "",
                type: "form"
              }
            },
            {
              type: "FbStep",
              label: "Step",
              icon: "tab",
              list: [],
              data: {
                label: "Step 1",
                value: ""
              }
            },
            {
              type: "FbLayout",
              label: "Layout",
              icon: "dashboard",
              list: [],
              data: {
                label: "",
                width: 100
              }
            },
          ]
        },
        {
          label: 'Content Elements',
          show: true,
          elements: [
            {
              type: "FbParagraph",
              label: "Paragraph",
              icon: "subject",
              list: [],
              data: {
                label: "Paragraph",
                value: "Paragraph"
              }
            },
            {
              type: "FbHtmlPackage",
              label: "H5P",
              icon: "extension",
              list: [],
              data: {
                label: "H5P",
                value: ""
              }
            },
            {
              type: "FbScorm",
              label: "Scorm",
              icon: "quiz",
              list: [],
              data: {
                label: "Scorm",
                value: ""
              }
            },
            {
              type: "FbQuiz",
              label: "Quiz",
              icon: "quiz",
              list: [],
              data: {
                label: "Quiz",
                value: ""
              }
            },
            {
              type: "FbInfoButtonTeaser",
              label: "Video Teaser",
              icon: "subscriptions",
              list: [],
              data: {
                label: "",
                value: "",
                teaser: "",
                description: ""
              }
            }
          ]
        },
        {
          label: 'Form Elements',
          show: true,
          elements: [
            {
              type: "FbRadioButton",
              label: "Radio",
              icon: "fiber_manual_record",
              list: [],
              data: {
                label: "Radio",
                other: false,
                options: [
                  {
                    label: "Radio 1",
                    value: "radio-1"
                  }
                ]
              }
            },
            {
              type: "FbCheckbox",
              label: "Checkbox",
              icon: "done",
              list: [],
              data: {
                label: "Checkbox",
                other: false,
                options: [
                  {
                    checked: false,
                    label: "Option 1",
                    value: "option-1"
                  }
                ]
              }
            },
            {
              type: "FbSelect",
              label: "Select",
              icon: "list",
              list: [],
              data: {
                label: "Select",
                multiple: false,
                options: [
                  {
                    checked: false,
                    label: "Option 1",
                    value: "option-1"
                  }
                ]
              }
            },
            {
              type: "FbLikert",
              label: "Likert",
              icon: "view_module",
              list: [],
              data: {
                label: "Likert",
                other: false,
                options: [
                  {
                    label: "Answer 1",
                    value: "1"
                  },
                  {
                    label: "Answer 2",
                    value: "2"
                  },
                  {
                    label: "Answer 3",
                    value: "3"
                  }
                ],
                sections: [
                  {
                    label: "Question 1"
                  },
                  {
                    label: "Question 2"
                  }
                ]
              }
            },
            {
              type: "FbStarRating",
              label: "Rating",
              icon: "star",
              list: [],
              data: {
                label: "Rating",
                value: 0,
                increment: 1,
                max_rating: 5,
                required: false
              }
            },
            {
              type: "FbDate",
              label: "Date",
              icon: "date_range",
              list: [],
              data: {
                label: "Select Date",
                value: ""
              }
            },
            {
              type: "FbInput",
              label: "Textfield",
              icon: "web_asset",
              list: [],
              data: {
                label: "Textfield",
                value: "",
                required: false
              }
            },

            // {
            //   type: "FbTag",
            //   label: "Tag",
            //   icon: "line_weight",
            //   list: [],
            //   data: {
            //     label: "Tag",
            //     chips: []
            //   }
            // },
            {
              type: "FbTextArea",
              label: "Textarea",
              icon: "video_label",
              list: [],
              data: {
                label: "Textarea",
              }
            },
            // {
            //   type: "FbExternalLink",
            //   label: "External Link",
            //   icon: "launch",
            //   list: [],
            //   data: {
            //     label: "",
            //     value: "",
            //     link: "#",
            //     link_desc: "Link description",
            //     helper_text: "Write a reflection",
            //     counter: "500",
            //     required: false
            //   }
            // },
            // {
            //   type: "FbRichText",
            //   list: [],
            //   data: {}
            // },
            {
              type: "FbFile",
              label: "File/Link Uploader",
              icon: "attach_file",
              list: [],
              data: {
                label: "File/Link Uploader",
                helptext:
                  "Add a file or link to evidence from the session (e.g., slideshow, agenda, photo, etc.)."
              }
            },
            {
              type: "FbVideo",
              label: "Video Uploader",
              icon: "attach_file",
              list: [],
              data: {
                label: "Video Uploader",
                helptext:
                  "Add a Video file to evidence from the session."
              }
            },
            {
              type: "FbInfoButton",
              label: "Info Button",
              icon: "web",
              list: [],
              data: {
                label: "",
                value: ""
              }
            },
          ]
        },
      ],
      list: [],
      value: {}
    };
  },
  methods: {
    init(data) {
      let textarea =
        this.$el.parentElement.parentElement.previousElementSibling.querySelector(
          "textarea"
        ) || document.querySelector("#form_builder_test_json");
      if (data) {
        textarea.value = data;
      }
      if (textarea) {
        let json = textarea.value && textarea.value != '' && textarea.value != '[]' ? textarea.value : '[{"type":"FbCard","list":[],"data":{"label":"Card","value":false,"type":"form","gatekeeping":false}}]';
        if (json == "") {
          json = "[]";
        }
        let p_json = JSON.parse(json);
        if (json != "" && p_json) {
          this.list = p_json;
          return;
        }
      }
    },
    addCard() {
      this.list.push(this.clone({
        type: "FbCard",
        label: "Card",
        icon: "tab",
        list: [],
        data: {
          label: "Card",
          value: "",
          type: "form"
        }
      }));
    },
    getOptions() {
      return {
        group: {
          name: "controls",
          pull: "clone",
          put: false
        },
        sort: false,
        clone: this.clone,
        move: this.move
      };
    },
    set_uuid(element) {
      if (!element.uuid) {
        element.uuid = this.$uuid.v1();
      }
      element.list.forEach(el => {
        if (!el.uuid) {
          el.uuid = this.$uuid.v1();
        }
        if (el.list && el.list.length) {
          this.set_uuid(el);
        }
      });
      return element;
    },
    removeItem(index) {
      this.list.splice(index, 1);
    },
    saveData(index, event) {
      this.list[index].data = event.data;
      this.list[index].list = event.list;
      let textarea = this.$el.parentElement.parentElement.previousElementSibling.querySelector(
        "textarea"
      );
      if (!textarea) return;
      this.$el.parentElement.parentElement.previousElementSibling.querySelector(
        "textarea"
      ).value = JSON.stringify(this.list);
    },
    clone(el) {
      return this.set_uuid({
        type: el.type,
        list: el.list.slice(),
        data: Object.assign({}, el.data)
      });
    },
    move(el) {
      return el.draggedContext.element.type != "FbDelimiter";

    },
    setValue(value) {
      if (value) {
        this.value[value.uuid] = value;
      }
    }
  },
  watch: {
    list: function(newList) {
      let textarea =
        this.$el.parentElement.parentElement.previousElementSibling.querySelector(
          "textarea"
        ) || document.querySelector("#form_builder_test_json");
      if (!textarea) return;
      textarea.value = JSON.stringify(newList);
    }
  }
};
</script>
<style lang="scss">
.full-height {
  min-height: 100%;
  // height: 100%;
}
.fb-controll-section{
  // .top-sticky {
  //   padding-top: 80px;
  // }
  .md-list.md-theme-default {
    background-color: transparent;
  }
  .sticky-wrapper {
    position: sticky;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
.vue-sticky-el {
  overflow: auto;
}
</style>
<style lang="scss">
.dragAreaInline,
.dragArea {
  position: relative;
  min-height: 80px;
  padding-bottom: 80px;
  &-bottom {
    &::before {
      top: auto !important;
      bottom: 0;
    }
  }
  ul.fb-controll-section {
    width: 100%;
  }
}
.w-100 {
  width: 100%;
}
.d-block {
  display: block;
}
.controll-wrapper {
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 15px;
  .md-link.w-100 {
    margin: 0;
  }
}
.controll-button {
  padding: 5px;
}
.group-controll {
  .md-ripple {
    width: 100%;
  }
  .md-button-content {
    width: 100%;
    .md-icon {
      margin: 0 5px;
    }
  }
}
.dragAreaConrol {
  overflow: hidden;
  transition: .3s;
  padding: 5px;
  &.visible {
    max-height: 2000px;
  }
  &.hidden {
    max-height: 0;
    display: block;
    opacity: 0;
  }
}
</style>

